// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-popover-container {
  width: 252px;
}
.notifications-popover-container .deck-notifications-header {
  display: flex;
  align-items: center;
  padding: 0;
}
.notifications-popover-container .deck-notifications-header h3 {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.notifications-popover-container .deck-notifications-header button {
  margin-left: auto;
  padding: 6px 8px;
  border: none;
  border-radius: 22px;
}
.notifications-popover-container .deck-notifications-filters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
}
.notifications-popover-container .deck-notifications-filters button {
  padding: 5px 13px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  border-radius: 22px;
  border: none;
  background: transparent;
}
.notifications-popover-container .deck-notifications-filters button.active {
  background: #F5F7FA;
}
.notifications-popover-container .deck-notifications-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.notifications-popover-container .deck-notifications-list .inactive {
  color: #747474 !important;
}
.notifications-popover-container .deck-notifications-list .inactive .deck-notifications-content * {
  color: #747474 !important;
}
.notifications-popover-container .deck-notifications-list .last-item {
  position: relative;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.notifications-popover-container .deck-notifications-content-outer {
  margin-right: 26px;
  color: black;
}
.notifications-popover-container .deck-notifications-content {
  margin-bottom: 8px;
}
.notifications-popover-container .deck-notifications-content p {
  margin-bottom: 8px;
}
.notifications-popover-container .deck-single-notification-more {
  float: right;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.notifications-popover-container .deck-notifications-item-meta {
  margin-bottom: 22px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
}
.notifications-popover-container .deck-notifications-options-menu-outer .ant-popover-content {
  min-width: 279px;
}
.notifications-popover-container .deck-notifications-options-menu {
  padding: 16px 10px;
  list-style-type: none;
}
.notifications-popover-container .deck-notifications-options-menu li {
  padding: 8px;
}
.notifications-popover-container .deck-notifications-options-menu button {
  padding: 0;
  border: none;
  background: transparent;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #444A53;
  cursor: pointer;
}
.notifications-popover-container .deck-notifications-options-menu button span {
  pointer-events: none;
}
.notifications-popover-container .deck-notifications-options-menu .nkl-deck-icon {
  margin-right: 14px;
}
.notifications-popover-container .deck-notifications-empty {
  text-align: center;
}
.notifications-popover-container .deck-notifications-empty img {
  width: 144px;
  margin: 72px 0 32px 0;
}
.notifications-popover-container .deck-notifications-empty h4 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: #444a53;
}
.notifications-popover-container .deck-notifications-empty p {
  font-size: 16px;
  line-height: 26px;
  font-weight: 300;
  color: rgba(68, 74, 83, 0.7);
}
.notifications-popover-container .deck-notifications-empty p:last-child {
  margin-bottom: 72px;
}
`, "",{"version":3,"sources":["webpack://./src/deck/notifications-popover/notifications-popover.less"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAFA;EAIQ,aAAA;EACA,mBAAA;EACA,UAAA;AACR;AAPA;EASY,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACZ;AAbA;EAgBY,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AAnBA;EAwBQ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAFR;AAzBA;EA8BY,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAFZ;AAIY;EACI,mBAAA;AAFhB;AArCA;EA6CQ,SAAA;EACA,UAAA;EACA,gBAAA;AALR;AA1CA;EAkDY,yBAAA;AALZ;AA7CA;EAsDoB,yBAAA;AANpB;AAhDA;EA4DY,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AATZ;AAtDA;EAoEQ,kBAAA;EACA,YAAA;AAXR;AA1DA;EAyEQ,kBAAA;AAZR;AA7DA;EA4EY,kBAAA;AAZZ;AAhEA;EAiFQ,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AAdR;AAvEA;EAyFQ,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAfR;AA7EA;EAiGY,gBAAA;AAjBZ;AAhFA;EAsGQ,kBAAA;EACA,qBAAA;AAnBR;AApFA;EA0GY,YAAA;AAnBZ;AAvFA;EA8GY,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AApBZ;AAjGA;EAwHgB,oBAAA;AApBhB;AApGA;EA6HY,kBAAA;AAtBZ;AAvGA;EAkIQ,kBAAA;AAxBR;AA1GA;EAqIY,YAAA;EACA,qBAAA;AAxBZ;AA9GA;EA0IY,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAzBZ;AApHA;EAiJY,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AA1BZ;AA1HA;EAwJY,mBAAA;AA3BZ","sourcesContent":[".notifications-popover-container {\n    width: 252px;\n\n    .deck-notifications-header {\n        display: flex;\n        align-items: center;\n        padding: 0;\n\n        h3 {\n            margin: 0;\n            font-size: 16px;\n            line-height: 24px;\n            font-weight: 600;\n        }\n\n        button {\n            margin-left: auto;\n            padding: 6px 8px;\n            border: none;\n            border-radius: 22px;\n        }\n    }\n\n    .deck-notifications-filters {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 10px;\n\n        button {\n            padding: 5px 13px;\n            font-size: 12px;\n            line-height: 16px;\n            font-weight: 600;\n            border-radius: 22px;\n            border: none;\n            background: transparent;\n\n            &.active {\n                background: #F5F7FA;\n            }\n        }\n    }\n\n    .deck-notifications-list {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        .inactive {\n            color: #747474 !important;\n\n            .deck-notifications-content {\n                * {\n                    color: #747474 !important;\n                }\n            }\n        }\n\n        .last-item {\n            position: relative;\n            width: 1px;\n            height: 1px;\n            overflow: hidden;\n        }\n    }\n\n    .deck-notifications-content-outer {\n        margin-right: 26px;\n        color: black;\n    }\n\n    .deck-notifications-content {\n        margin-bottom: 8px;\n\n        p {\n            margin-bottom: 8px;\n        }\n    }\n\n    .deck-single-notification-more {\n        float: right;\n        padding: 0;\n        border: none;\n        background: transparent;\n        cursor: pointer;\n    }\n\n    .deck-notifications-item-meta {\n        margin-bottom: 22px;\n        font-size: 12px;\n        line-height: 16px;\n        font-weight: 600;\n    }\n\n    .deck-notifications-options-menu-outer {\n        .ant-popover-content {\n            min-width: 279px;\n        }\n    }\n\n    .deck-notifications-options-menu {\n        padding: 16px 10px;\n        list-style-type: none;\n\n        li {\n            padding: 8px;\n        }\n\n        button {\n            padding: 0;\n            border: none;\n            background: transparent;\n            font-size: 14px;\n            line-height: 20px;\n            font-weight: 600;\n            color: #444A53;\n            cursor: pointer;\n\n            span {\n                pointer-events: none;\n            }\n        }\n\n        .nkl-deck-icon {\n            margin-right: 14px;\n        }\n    }\n\n    .deck-notifications-empty {\n        text-align: center;\n\n        img {\n            width: 144px;\n            margin: 72px 0 32px 0;\n        }\n\n        h4 {\n            font-size: 24px;\n            line-height: 32px;\n            font-weight: 600;\n            color: rgba(68, 74, 83, 1);\n        }\n\n        p {\n            font-size: 16px;\n            line-height: 26px;\n            font-weight: 300;\n            color: rgba(68, 74, 83, 0.7);\n        }\n\n        p:last-child {\n            margin-bottom: 72px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
